var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_5219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.833252C8.95 0.833252 0 9.63325 0 20.4866C0 29.1716 5.73 36.5366 13.675 39.1333C14.675 39.3183 15.0417 38.7099 15.0417 38.1883C15.0417 37.7216 15.025 36.4849 15.0167 34.8466C9.45333 36.0316 8.28 32.2099 8.28 32.2099C7.37 29.9416 6.055 29.3349 6.055 29.3349C4.24333 28.1166 6.195 28.1416 6.195 28.1416C8.20333 28.2783 9.25833 30.1666 9.25833 30.1666C11.0417 33.1716 13.94 32.3033 15.0833 31.8016C15.2633 30.5299 15.7783 29.6649 16.35 29.1733C11.9083 28.6816 7.24 26.9916 7.24 19.4616C7.24 17.3166 8.015 15.5633 9.29833 14.1883C9.07333 13.6916 8.39833 11.6933 9.47333 8.98659C9.47333 8.98659 11.1483 8.45992 14.9733 11.0016C16.5733 10.5649 18.2733 10.3483 19.9733 10.3383C21.6733 10.3483 23.3733 10.5649 24.9733 11.0016C28.7733 8.45992 30.4483 8.98659 30.4483 8.98659C31.5233 11.6933 30.8483 13.6916 30.6483 14.1883C31.9233 15.5633 32.6983 17.3166 32.6983 19.4616C32.6983 27.0116 28.0233 28.6733 23.5733 29.1566C24.2733 29.7466 24.9233 30.9516 24.9233 32.7933C24.9233 35.4233 24.8983 37.5366 24.8983 38.1749C24.8983 38.6899 25.2483 39.3049 26.2733 39.1083C34.275 36.5283 40 29.1583 40 20.4866C40 9.63325 31.045 0.833252 20 0.833252Z",
    fill: "#423B46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_5219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e8edd5687c71d99126f16c0f1c945de3.svg";
export { ForwardRef as ReactComponent };